import { Orientation, RatioType } from 'video-editor-renderer'
import { t } from '@/lang'

export interface RatioOptionsModel {
  type: string
  label: string
  children: {
    value: RatioType
    label: RatioType
    disabled?: boolean
    description: string
  }[]
}

export const ratioOptions: RatioOptionsModel[] = [
  {
    type: Orientation.Vertical as string,
    label: t('basic.ratioSelector.vertical').toString(),
    children: [
      {
        value: RatioType['9:16'],
        label: RatioType['9:16'],
        description: 'Mintegral, TikTok ads, Instagram',
      },
      {
        value: RatioType['3:4'],
        label: RatioType['3:4'],
        description: 'Mintegral',
      },
      {
        value: RatioType['4:5'],
        label: RatioType['4:5'],
        description: 'Facebook Feed',
      },
      {
        value: RatioType['1:1'],
        label: RatioType['1:1'],
        description: 'Instagram posts, TikTok ads',
      },
    ],
  },
  {
    type: Orientation.Landscape as string,
    label: t('basic.ratioSelector.horizontal').toString(),
    children: [
      {
        value: RatioType['16:9'],
        label: RatioType['16:9'],
        description: 'Mintegral, YouTube ads, TikTok ads',
      },
      {
        value: RatioType['4:3'],
        label: RatioType['4:3'],
        description: 'Mintegral, LinkedIn ads, Facebook videos',
      },
      {
        value: RatioType['2:1'],
        label: RatioType['2:1'],
        description: 'Facebook',
      },
    ],
  },
]
